var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniStopsTimes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "14px",
    viewBox: "0 0 26 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-34"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "+",
    fillOpacity: 0.6,
    fill: "#121212",
    fillRule: "nonzero",
    transform: "translate(22.228823, 6.861177) rotate(-315.000000) translate(-22.228823, -6.861177) ",
    points: "22.9279751 11.3611775 22.9279751 7.49677071 26.7415344 7.49677071 26.7415344 6.22558427 22.9279751 6.22558427 22.9279751 2.36117749 21.52967 2.36117749 21.52967 6.22558427 17.7161106 6.22558427 17.7161106 7.49677071 21.52967 7.49677071 21.52967 11.3611775"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-74",
    fill: "#6B63CB",
    cx: 7,
    cy: 7,
    r: 7
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniStopsTimes);
export default __webpack_public_path__ + "static/media/mini-stops-times.a3416724a23b14bf070e4ba2b2e46262.svg";
export { ForwardRef as ReactComponent };